"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorMessageEnum = exports.ErrorMessageTypeEnum = void 0;
var ErrorMessageTypeEnum;
(function (ErrorMessageTypeEnum) {
    ErrorMessageTypeEnum["ADD"] = "ADD";
    ErrorMessageTypeEnum["LOAD"] = "LOAD";
    ErrorMessageTypeEnum["REMOVE"] = "REMOVE";
})(ErrorMessageTypeEnum || (exports.ErrorMessageTypeEnum = ErrorMessageTypeEnum = {}));
const ErrorMessageEnum = (messageType) => {
    let ErrorMessage;
    (function (ErrorMessage) {
        ErrorMessage["ADD"] = "Nab\u00EDdku se nepoda\u0159ilo p\u0159idat do obl\u00EDben\u00FDch.";
        ErrorMessage["LOAD"] = "Nepoda\u0159ilo se na\u010D\u00EDst stav obl\u00EDben\u00FDch nab\u00EDdek.";
        ErrorMessage["REMOVE"] = "Nab\u00EDdku se nepoda\u0159ilo odebrat z obl\u00EDben\u00FDch.";
    })(ErrorMessage || (ErrorMessage = {}));
    if (messageType) {
        return ErrorMessage[messageType];
    }
    return null;
};
exports.ErrorMessageEnum = ErrorMessageEnum;
